<template>
  <div class="wrapper" id="mainId">
    <div class="wrapper_header">
      <div class="wrapper_header_name">智能工厂生产监控平台</div>
      <div class="date">最近更新：{{currentDate}}</div>
      <div class="exit"  @click="changeStatus"><span style="padding-left:45px">{{status}}全屏</span></div>
    </div>
    <div class="wrapper_top">
      <div class="wrapper_top_left">
        <Topleft></Topleft>
      </div>
      <div class="wrapper_top_center">
        <Topcenter></Topcenter>
      </div>
      <div class="wrapper_top_right">
        <Topright></Topright>
      </div>
    </div>
    <div class="wrapper_bottom">
      <div class="wrapper_bottom_left">
        <Bottomleft></Bottomleft>
      </div>
      <div class="wrapper_bottom_right">
        <Bottomright></Bottomright>
      </div>
    </div>
  </div>
</template>
<script>
import { toggle } from '@/utils/util.js';
import moment from 'moment'
import Topleft from './components/topleft.vue'
import Topcenter from './components/topcenter.vue'
import Topright from './components/topright.vue'
import Bottomleft from './components/bottomleft.vue'
import Bottomright from './components/bottomright.vue'
export default {
  components: {
    Topleft,
    Topcenter,
    Topright,
    Bottomleft,
    Bottomright
  },
  data() {
    return {
      currentDate: moment().format('YYYY-MM-DD HH:mm'),
      status:'退出'
    }
  },
  created() {
    var _this = this
    this.changeStatus()
    this.$nextTick(function(){
      // 全屏的时候keydown监听不到 所以不能监听鼠标按下事件
      document.addEventListener('fullscreenchange', function(event) {
        var isFull = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen
        if(isFull == false){
          _this.$router.push({ path: '/home/Home' })
        }
      });
    })
  },
  methods: {
    changeStatus(){
      this.$nextTick(function(){
        let dom = document.getElementById('mainId');
        toggle(dom);
        setTimeout(function(){
          var isFull = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen
          if(isFull == false){
            this.$router.push({ path: '/home/Home' })
          }
          this.status = (isFull == true?'退出':'打开')
        }.bind(this),100)
      })
    },
  },
  beforeDestroy() {

  }
}
</script>

<style scoped>
.wrapper {
  height: 100vh;
  width: 100vw;
  background: rgb(7,17,45);
  box-sizing: border-box;
  position: relative;
}
.wrapper_header {
  height: 19%;
  width: 100%;
  background: url(./img/head.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.wrapper_header_name {
  width: 100%;
  text-align: center;
  font-weight: 800;
  font-size: 32px;
  letter-spacing: 5px;
  background-image: linear-gradient(#58fcff,#01a3fd);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.wrapper_header .date {
  color: #04f9fe;
  font-size: 16px;
  position: absolute;
  top: 10px;
  left: 30px;
}
.wrapper_header .exit{
  color: #04f9fe;
  font-size: 16px;
  background: url(./img/exit.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 10px;
  right: 30px;
  cursor: pointer;
}
.wrapper_top {
  height: 52%;
  width: 99%;
  display: flex;
  position: absolute;
  top: 7%;
  left: 1%;
}
.wrapper_top_left {
  min-width: 300px;
  width: 32%;
  height: 100%;
  background: url(./img/borderTop.png) no-repeat;
  background-size: 100% 100%;
}
.wrapper_top_center {
  min-width: 550px;
  width: 34%;
  height: 100%;
  background: url(./img/borderTopMid.png) no-repeat;
  background-size: 100% 100%;
  /* margin: 0 0.6%; */
}
.wrapper_top_right {
  min-width: 340px;
  width: 32%;
  height: 100%;
  background: url(./img/borderTop.png) no-repeat;
  background-size: 100% 100%;
}
.wrapper_bottom {
  height: 39%;
  width: 99%;
  display: flex;
  position: absolute;
  top: 60%;
  left: 1%;
}
.wrapper_bottom_left {
  width: 58%;
  height: 100%;
  background: url(./img/borderBottom_left.png) no-repeat;
  background-size: 100% 100%;
}
.wrapper_bottom_right {
  width: 40%;
  height: 100%;
  background: url(./img/borderBottom_right.png) no-repeat;
  background-size: 100% 100%;
}

</style>
<style>
/* .el-table__body-wrapper */
  /* 全局滚动条样式 */
  ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  }
  ::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/views/workshopSignage/workshopSignage/MainLayout.vue